<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
  >
  </c-search-form>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Tra cứu Xu",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phoneNumber",
          label: "Số điện thoại",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'ID tài khoản',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumber',
          text: 'Số điện thoại',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'accountName',
          text: 'Tên học sinh',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'message1',
          text: 'Số Xu Tích Lũy Tuần 1',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'message2',
          text: 'Số Xu Tích Lũy Tuần 2',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'message',
          text: 'Tổng Số Xu Tích Lũy',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        }
      ]
    }
  },
  methods: {},
  created() {
    let startDate = this.$route.params.startDate;
    this.searchUrl = `/kidAccountClass/searchCoinByPhoneTwoWeek/${startDate}`;
  }
}
</script>
